import React from 'react'
import PortfolioStyle from './portfolio-style'
import TitleButton from '../skills/title-button'
import Bhariya from '../../common/assets/portfolio/bhariya-login.png'
import GHCA from '../../common/assets/portfolio/ghca.png'
import IMS from '../../common/assets/portfolio/ims.png'
import KidsCare from '../../common/assets/portfolio/kids-care.png'
import Clevero from '../../common/assets/portfolio/clevero.png'
import TechChannel from '../../common/assets/portfolio/technology-channel.png'
import PortfolioImage from './portfolio-image'

const Portfolio = () => {
    return (
        <PortfolioStyle>
            <div id="title">
                <TitleButton>Portfolio</TitleButton>
            </div>
            <div id="portfolio-image">
                    <PortfolioImage image={Clevero} name='Clevero' url="https://clevero.co" />
                    <PortfolioImage image={TechChannel} name='Technology Channel Tools' url="https://tools.technologychannel.org" />
                    <PortfolioImage image={Bhariya} name='Bhariya' url="https://bhariya.com.np" />
                    <PortfolioImage image={KidsCare} name='Kids Care' />
                    <PortfolioImage image={GHCA} name='GHCA' />
                    <PortfolioImage image={IMS} name='Ims' />
            </div>
        </PortfolioStyle>
    )
}

export default Portfolio